import React from 'react';

export const GreetingComponent = ({ user }) => {
  const currentHour = new Date().getHours();
  let greeting = "Good Morning";
  
  if (currentHour >= 12 && currentHour < 17) {
    greeting = "Good Afternoon";
  } else if (currentHour >= 17) {
    greeting = "Good Evening";
  }

  // Try different possible property names for the first name
  const firstName = user?.firstName || user?.first_name || user?.name?.split(' ')[0] || '---';

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center overflow-hidden">
      <div className="max-w-[800px] w-full mx-auto px-4">
        <div className="text-center w-full">
          <div style={{ animation: 'fade-in 0.8s ease-out forwards' }} className="opacity-0">
            <div className="text-xl sm:text-2xl font-['midus-sans'] font-normal leading-none">
              {greeting.trim()},
            </div>
            <div className="text-[65px] sm:text-[80px] font-['midus-sans'] font-normal leading-tight">
              {firstName}
            </div>
          </div>
          <div className="text-lg sm:text-xl font-['midus-sans'] font-normal mt-8 sm:mt-10 leading-none flex justify-center opacity-0" 
               style={{ animation: 'fade-in-no-move 0.1s ease-out 0.8s forwards' }}>
            <div className="typing-container">
              <span className="typing-text">How can I help?</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 